<template>
  <div>
    <custom-tabs
      v-model="tabs"
      :tab-items="[{ text: 'ارتقا' }, { text: 'پله' }]"
      grow
    >
      <template v-slot:staticItems>
        <v-tab-item>
          <div v-if="post_costs.length > 0">
            <v-dialog
              v-if="openClockModal"
              v-model="openClockModal"
              max-width="500"
              transition="dialog-bottom-transition"
            >
              <template v-slot:default="dialog">
                <v-card>
                  <v-toolbar color="primary" dark>{{ extraData }} </v-toolbar>
                  <v-card-text>
                    <div
                      v-for="(item, index) in count"
                      class="col-md mx-auto d-flex py-1 pt-4 mt-3"
                    >
                      <UpgradeClock :key="index"></UpgradeClock>
                      <v-btn
                        class=""
                        color="success"
                        icon
                        outlined
                        small
                        @click="count.push(Math.random())"
                      >
                        <i
                          class="fa fa-plus text-success"
                          style="font-size: 9pt"
                        ></i>
                      </v-btn>
                      <v-btn
                        v-if="count.length > 1"
                        class="mx-1"
                        color="error"
                        icon
                        outlined
                        small
                        @click="removeDate(index)"
                      >
                        <i
                          class="fa fa-minus text-danger"
                          style="font-size: 9pt"
                        ></i>
                      </v-btn>
                    </div>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn color="error" text @click="openClockModal = false"
                      >بستن
                    </v-btn>
                    <v-btn
                      :loading="loading"
                      class="float-left"
                      color="primary"
                      text
                      @click="submitClock()"
                    >
                      ثبت
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
            <v-tabs color="deep-purple accent-4" left>
              <v-tab>ارتقا</v-tab>
              <v-tab>ارتقا دوره ای</v-tab>
              <v-tab-item>
                <v-container fluid>
                  <v-radio-group>
                    <div v-for="(item, index) in post_costs">
                      <v-radio
                        :key="item.id"
                        :label="item.title + ' - ' + item.price + item.unit"
                        :value="item.id"
                        class="mt-4 mb-0 pb-0"
                        color="red darken-3"
                        style="font-size: 8pt !important"
                        @change="setCost(item.id, item.mandatory)"
                      ></v-radio>
                      <p
                        v-if="item.until > 0"
                        class="text-right py-0 my-0 pr-5 text-info"
                        style="font-size: 10px"
                      >
                        {{ secondToHuman(item.until) }}
                      </p>
                      <p
                        class="text-right pr-5 text-justify text-dark-50 py-0 my-0"
                        style="font-size: 8.5pt; line-height: 1.5rem"
                      >
                        {{ item.description }}
                      </p>
                    </div>
                  </v-radio-group>
                  <v-row>
                    <v-btn
                      :disabled="haveTime"
                      :loading="loading"
                      class="submit-btn mr-auto"
                      @click="directPay"
                    >
                      <span class="fa fa-paper-plane pl-1"></span>
                      پرداخت مستقیم
                    </v-btn>
                    <v-btn
                      :loading="loading"
                      class="submit-btn ml-auto"
                      @click="autoPay"
                    >
                      <span class="fa fa-paper-plane pl-1"></span>
                      پرداخت اتوماتیک
                    </v-btn>
                  </v-row>
                </v-container>
              </v-tab-item>
              <v-tab-item>
                <v-container fluid>
                  <v-radio-group>
                    <div
                      v-for="(item, index) in post_costs.filter(
                        (x) => x.available
                      )"
                    >
                      <v-radio
                        :key="item.id"
                        :label="item.title + ' - ' + item.price + item.unit"
                        :value="item.id"
                        class="mt-4"
                        color="red darken-3"
                        style="font-size: 8pt !important"
                        @change="setCost(item.id, item.mandatory)"
                        @click="
                          openClock(
                            item.id,
                            item.title + ' - ' + item.price + item.unit
                          );
                          openClockModal = true;
                        "
                      ></v-radio>
                      <p
                        class="text-right pr-5 text-justify text-dark-50 py-0 my-0"
                        style="font-size: 8.5pt; line-height: 1.5rem"
                      >
                        {{ item.description }}
                      </p>
                    </div>
                  </v-radio-group>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </div>
          <div v-else>
            <div v-if="loading" class="d-flex justify-content-center">
              <div id="loading">
                <v-icon color="primary" size="6rem">mdi-loading</v-icon>
              </div>
            </div>

            <h2 v-else class="text-danger text-center mx-auto">
              متاسفانه شماره یا آگهی شما دچار مشکل شده است.
            </h2>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div v-if="!pelleLoading && pelleItems.length">
            <v-radio-group>
              <v-radio
                v-for="pelle in pelleItems"
                :key="pelle.key"
                :label="pelle.title"
                :value="pelle.key"
                class="mt-4 mb-0 pb-0"
                color="red darken-3"
                style="font-size: 8pt !important"
                @change="selectedPelle = pelle.key"
              ></v-radio>
            </v-radio-group>

            <v-btn
              :loading="pelleLoading"
              class="submit-btn ml-auto"
              @click="payPelle"
            >
              <v-icon left>mdi-account-credit-card-outline</v-icon>
              پرداخت
            </v-btn>
          </div>

          <h3 v-else class="text-muted text-center my-3">
            هیچ ایتمی یافت نشد.
          </h3>
        </v-tab-item>
      </template>
    </custom-tabs>
  </div>
</template>

<script>
import MultiTimes from "@/view/pages/ads/sendAds/multiTimes";
import TimrWithDays from "@/view/pages/ads/sendAds/timrWithDays";
import UpgradeClock from "@/view/pages/ads/adsList/UpgradeClock";
import { Axios2, Bus } from "@/main";
import { mapGetters } from "vuex";

export default {
  name: "payUpgrade",

  components: { UpgradeClock, TimrWithDays, MultiTimes },

  props: {
    token: {
      type: String,
      default: "",
    },
    modal: {
      default: false,
    },
  },

  data() {
    return {
      post_costs: [],
      cost: "",
      count: [1],
      times: [],
      extraData: "",
      mandatory: true,
      available: true,
      haveTime: false,
      openClockModal: false,
      loading: false,
      pelleLoading: false,
      pelleItems: [],
      selectedPelle: undefined,
      tabs: 0,
    };
  },

  beforeMount() {
    this.getPostCosts();
  },

  mounted() {
    Bus.$on("getTimes", (val, key) => {
      this.times[key] = val;
    });
  },

  computed: {
    ...mapGetters("ribbon", {
      core: "core",
    }),
  },

  watch: {
    token() {
      this.reset();
      this.getPostCosts();
      this.getPelle();
    },
    cost: function (val) {
      const meqdar = this.post_costs.filter((x) => x.id === val);
      this.haveTime = meqdar[0]["until"] > 0;
    },
  },

  methods: {
    reset() {
      this.post_costs = [];
      this.cost = "";
      this.count = [1];
      this.times = [];
      this.extraData = "";
      this.mandatory = true;
      this.available = true;
      this.haveTime = false;
      this.openClockModal = false;
    },
    getPostCosts(count = 0) {
      this.loading = true;
      $.ajax({
        url: `${url}/divar/advertise/costs/${this.token}`,
        type: "GET",
        fn: this.getPostCosts,
        msg: false,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: (data) => {
          this.post_costs = data.data;
        },
        error: async ({ status, responseJSON }) => {
          await new Promise((resolve) => setTimeout(resolve, 1_500));

          if (count < 3) this.getPostCosts(++count);
        },
      }).always(() => {
        this.loading = false;
      });
    },
    setCost(id, mandatory) {
      this.cost = Number(id);
    },
    directPay() {
      let pack = this.core.pack[0];
      let hasPanel = [18, 19, 25, 26, 27].indexOf(pack.id) > 0;

      // this.usersPanel.forEach(item => hasPanel = hasPanel && [18, 19, 25, 26, 27].indexOf(item) > 0)

      if (!hasPanel) {
        this.$modal.error(
          "",
          "برای استفاده از پردخت مستقیم ابتدا باید پنل دیوار را خریداری فرمایید.",
          "",
          {
            text: "خرید پنل",
            icon: "fa-plus",
            class: "btn col-md-12 btn-outline-lightGreen my-1",
            onClick() {
              window.open(this.$coreApi + "/#/panel", "_blank");
            },
          }
        );
      } else {
        this.loading = true;
        $.ajax({
          url: `${url}/divar/advertise/costs/${this.token}/pay`,
          method: "POST",
          fn: this.directPay,
          headers: {
            ACCEPT: "application/json",
            Authorization: Token,
            "Content-Type": "application/json",
          },
          data: JSON.stringify({
            cost: this.cost,
            type: "direct",
          }),
          success: (data) => {
            window.open(data.data.payment_url, "_blank");
            this.modal();
          },
        }).always(() => {
          this.loading = false;
        });
      }
    },
    autoPay() {
      this.loading = true;

      $.ajax({
        url: `${url}/divar/advertise/costs/${this.token}/pay`,
        method: "POST",
        fn: this.autoPay,
        msg: true,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          cost: this.cost,
          type: "automatic",
        }),
        success: () => {
          this.modal();
        },
      }).always(() => {
        this.loading = false;
      });
    },
    secondToHuman(second) {
      const suffix = second > 0 ? " دیگر " : " پیش";

      second = Math.abs(Number(second));
      let day = Math.floor(second / 86400);
      let hour = Math.floor((second % 86400) / 3600);
      let minutes = Math.floor((second % 3600) / 60);
      second = Math.floor((second % 3600) % 60);

      return (
        `${Math.abs(day)} روز و ${Math.abs(hour)} ساعت و ${Math.abs(
          minutes
        )} دقیقه و  ${Math.abs(second)} ثانیه` + suffix
      );
    },
    openClock: function (id, extra) {
      this.openClockModal = true;
      this.extraData = extra;
    },
    removeDate(index) {
      this.count.splice(index, 1);
      this.times.splice(index, 1);
    },
    submitClock() {
      this.loading = true;

      $.ajax({
        url: `${url}/divar/advertise/costs/${this.token}/pay`,
        method: "POST",
        fn: this.submitClock,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          cost: this.cost,
          type: "gradual",
          times: this.times,
        }),
        success: (data) => {
          this.openClockModal = false;
        },
      }).always(() => {
        this.loading = false;
      });
    },
    getPelle() {
      this.pelleLoading = true;

      Axios2.get("divar/pelle/" + this.token)
        .then((res) => {
          this.pelleItems = res.data.data;
        })
        .catch(() => {})
        .finally(() => {
          this.pelleLoading = false;
        });
    },
    payPelle() {
      this.pelleLoading = true;

      Axios2.post("divar/pelle/" + this.token, {
        item: this.selectedPelle,
      })
        .then((res) => {
          this.modal();
        })
        .catch(() => {})
        .finally(() => {
          this.pelleLoading = false;
        });
    },
  },
};
</script>

<style scoped>
@keyframes spinner {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

#loading {
  animation: spinner 1.5s linear infinite;
}
</style>
